export default __webpack_public_path__ + "static/media/VO_SMILING_FEMALE__Price.4a47e085.png";